'use client';

// #region IMPORT
import type { ReactNode } from 'react';

import { useState } from 'react';

import { Box, Stack, useTheme, Container } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

import { AiView } from '../components/ai-view';
import { Overview } from '../components/overview';
import { Sercurity } from '../components/sercurity';
import { LandingHero } from '../components/landing-hero';
import { ZaloFeature } from '../components/zalo-feature';
import { Intergration } from '../components/intergration';
import { TeachingFeature } from '../components/teaching-features';
import { CustomerElearning } from '../components/customer-elearning';
import { HightlightFeatures } from '../components/hightlight-features';
import { CenterRegisterForm } from '../components/center-register-form';
import { TestimonialElearning } from '../components/testimonial-elearning';
// #endregion
// ----------------------------------------------------------------------

const Bg = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 359"
      fill="none"
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient
          id="paint0_linear_1301_49848"
          x1="720.153"
          y1="97.5764"
          x2="720.153"
          y2="332.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor={isDark ? '#2C2C35' : '#FAFAFF'} />
          <stop offset="80%" stopColor={isDark ? '#2C2C35' : '#FAFAFF'} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path
        d="M-261 358.295V65.4034C-260.864 65.3777 -260.7 65.3468 -260.508 65.3109C-259.85 65.1875 -258.863 65.0045 -257.548 64.7655C-254.917 64.2878 -250.974 63.5868 -245.726 62.6946C-235.23 60.9101 -219.515 58.3606 -198.646 55.3008C-156.906 49.1814 -94.5445 41.0216 -12.0667 32.8616C152.888 16.5414 398.309 0.220459 720.153 0.220459C1041.99 0.220459 1287.41 16.5414 1452.37 32.8616C1534.85 41.0216 1597.21 49.1814 1638.95 55.3008C1659.83 58.3606 1675.53 60.9101 1686.03 62.6946C1691.27 63.5868 1695.23 64.2878 1697.85 64.7655C1699.17 65.0045 1700.16 65.1875 1700.82 65.3109C1701 65.3468 1701.17 65.3777 1701.31 65.4034V358.295L1700.28 358.146C1699.13 357.981 1697.42 357.736 1695.19 357.416C1690.71 356.777 1684.1 355.839 1675.54 354.647C1658.42 352.26 1633.55 348.852 1602.51 344.761C1540.42 336.581 1453.64 325.674 1354.88 314.767C1157.36 292.953 911.889 271.136 720.153 271.136C528.417 271.136 282.948 292.953 85.4286 314.767C-13.3347 325.674 -100.115 336.581 -162.205 344.761C-193.251 348.852 -218.123 352.26 -235.235 354.647C-243.791 355.839 -250.406 356.777 -254.883 357.416C-257.121 357.736 -258.825 357.981 -259.969 358.146C-260.388 358.207 -260.732 358.256 -261 358.295Z"
        fill="url(#paint0_linear_1301_49848)"
      />
    </svg>
  );
};

export function LandingPageView() {
  const smUp = useResponsive('up', 'sm');

  const [openRegisterForm, setOpenRegisterForm] = useState(false);

  return (
    <>
      <LandingHero onOpenRegisterForm={(value: boolean) => setOpenRegisterForm(value)} />
      <Stack position="relative">
        <Box
          position="absolute"
          sx={{
            width: 1,
            height: 1,
            zIndex: -1,
          }}
        >
          <Bg />
        </Box>
        <Container>
          <CustomerElearning />
        </Container>
      </Stack>
      <Overview onOpenRegisterForm={(value: boolean) => setOpenRegisterForm(value)} />
      <HightlightFeatures />
      <Container>
        <TeachingFeature />
      </Container>
      <ZaloFeature />
      <AiView onOpenRegisterForm={(value: boolean) => setOpenRegisterForm(value)} />
      <ResponsiveWrapper
        isSmUp={smUp}
        wrapper={(children) => <Container maxWidth="xl">{children}</Container>}
      >
        <Intergration onOpenRegisterForm={(value: boolean) => setOpenRegisterForm(value)} />
      </ResponsiveWrapper>
      <TestimonialElearning />
      <Sercurity />
      {openRegisterForm && (
        <CenterRegisterForm open={openRegisterForm} onClose={() => setOpenRegisterForm(false)} />
      )}
    </>
  );
}

type ResponsiveWrapperProps = {
  isSmUp: boolean;
  wrapper: (children: ReactNode) => ReactNode;
  children: ReactNode;
};

const ResponsiveWrapper = ({ isSmUp, wrapper, children }: ResponsiveWrapperProps) =>
  isSmUp ? wrapper(children) : children;
